import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Product", id: "hero" },
  { label: "The Data", id: "data" },
  { label: "Architecture", id: "architecture" },
  { label: "Advantage", id: "advantage" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/80 backdrop-blur-xl border-b border-slate-200/70 shadow-[0_8px_30px_-15px_rgba(15,23,42,0.15)]" : "bg-transparent"
      }`}
    >
      <nav className="container-x flex h-16 items-center justify-between md:h-20">
        <button data-testid="nav-logo" onClick={() => scrollTo("hero")} className="flex items-center gap-2">
          <img src="/s1ep-logo.png" alt="S1EP" className="h-7 w-auto md:h-8" />
        </button>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-medium text-ink-soft transition-colors hover:text-accent"
            >
              {l.label}
            </button>
          ))}
        </div>

        <motion.button
          data-testid="nav-cta"
          onClick={() => scrollTo("contact")}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          transition={{ type: "spring", stiffness: 400, damping: 16 }}
          className="btn-pill bg-ink px-5 py-2.5 text-sm text-white hover:bg-accent"
        >
          Send an Enquiry
        </motion.button>
      </nav>
    </motion.header>
  );
}
